/** @jsxImportSource theme-ui */
import { Box, Button, Flex, Heading, IconButton, Link, Text } from "theme-ui";
import { ReactComponent as Coffee } from "../../assets/coffee.svg";
import { ReactComponent as Resume } from "../../assets/resume.svg";
import { ReactComponent as Linkedin } from "../../assets/linkedin.svg";
import { ReactComponent as Mail } from "../../assets/mail.svg";
import Spacer from "../common/Spacer";
import { LINKS } from "../../utils/constants";
import { coffee, fadeIn, fadeInUp, slideUpReg } from "../../utils/animations";

export default function Hero() {
  return (
    <Flex
      sx={{
        height: [
          "auto",
          "calc(100vh - var(--top-margin) - var(--nav-height) - 300px - var(--home-hero-work-spacer))",
        ],
        maxHeight: "800px",
        minHeight: "340px",
        flexDirection: "column",
        justifyContent: "center",
        pt: ["80px", 0],
        pb: ["60px", 0],
      }}
    >
      <Flex
        sx={{
          alignItems: "center",
          gap: "8px",
          animation: `${fadeIn} 1.3s cubic-bezier(0.24, 0.74, 0.42, 0.98)`,
          animationFillMode: "both",
          animationDelay: "0.4s",
          svg: {
            overflow: "visible",
            ".steam": {
              animation: `${coffee} 2s linear infinite`,
              opacity: 0,
            },
            path: {
              "&:nth-of-type(3)": {
                animationDelay: "-0.7s",
              },
              "&:nth-of-type(5)": {
                animationDelay: "-1.3s",
              },
            },
          },
        }}
      >
        <Text variant="caption">Hi, I'm Derman!</Text>
        <Coffee />
      </Flex>
      <Spacer height={["30px", "19px"]} />
      <Box sx={{ overflow: "hidden", width: "100%" }}>
        <Heading
          variant="h1"
          sx={{
            width: "100%",
            fontSize: [4, 5], // Scaled down from h1 default [5, 6]
            lineHeight: "1.3", // Consistent line height for multi-line heading
            strong: { fontWeight: "bold", color: "strong" },
            color: "strong",
          }}
        >
          <Box
            sx={{
              display: "inline-block",
              animation: `${fadeInUp} 1s cubic-bezier(0.24, 0.74, 0.42, 0.98)`,
              animationFillMode: "both",
              animationDelay: "1s",
              lineHeight: "inherit", // Inherit from parent
            }}
          >
            <strong>A Toronto based Product Designer</strong> with a passion for
            designing elegant and{" "}
            <strong>intuitive data driven experiences.</strong>
          </Box>
          <br />
            <Box
            as="strong"
            sx={{
              display: "block",
              marginTop: ["1em", "0.5em"],
              width: "100%",
              opacity: 0,
              transform: "none",
              animation: `${fadeIn} 1.3s cubic-bezier(0.24, 0.74, 0.42, 0.98)`,
              animationFillMode: "both",
              animationDelay: "1.3s",
              fontWeight: "bold",
              color: "strong",
              lineHeight: "inherit", // Inherit from parent for consistency
            }}
          >
            Currently driving growth design{" "}
            <Link
              href="https://www.confluent.io/"
              target="_blank"
              sx={{ 
                color: "accent", 
                fontWeight: "bold",
                fontSize: "inherit",
                textDecoration: "none",
                borderBottom: "none",
                transition: "opacity 0.2s ease",
                "&:hover": {
                  opacity: 0.7,
                },
              }}
            >
              @Confluent
            </Link>{" "}
            the world's leading data streaming platform.
          </Box>
        </Heading>
      </Box>
      <Spacer height={["50px", "35px"]} />
      <Flex
        sx={{
          gap: ["15px", "30px"],
          animation: `${fadeIn} 1.3s cubic-bezier(0.24, 0.74, 0.42, 0.98)`,
          animationFillMode: "both",
          animationDelay: "2s",
        }}
      >
        <Button
          as={Link}
          href={LINKS.RESUME}
          target="_blank"
          sx={{
            lineHeight: "160%",
            minWidth: "150px",
            svg: {
              mr: "7px",
              width: "14px",
              height: "auto",
            },
          }}
        >
          <Resume /> Resume
        </Button>
        <Flex sx={{ gap: "9px" }}>
          <IconButton as={Link} href={LINKS.LINKEDIN} target="__blank">
            <Linkedin />
          </IconButton>
          <IconButton as={Link} href={LINKS.EMAIL} variant="iconStroke">
            <Mail />
          </IconButton>
        </Flex>
      </Flex>
    </Flex>
  );
}
